import http from "@/axios/http-common";
import { RiwayatRegisterResponse } from "@/types/riwayat";

class RiwayatPemeriksaan {
  async listRegister(
    rm: string,
    page: number,
    perPage: number
  ): Promise<RiwayatRegisterResponse> {
    const response = await http.getDataParam(`/pasien/${rm}/register`, {
      params: { per_page: perPage, page, expand: "ringkas" }
    });

    return response.data;
  }

  async iterObat(rm: string): Promise<unknown> {
    const response = await http.getData(`/pasien/${rm}/iter-obat`);

    return response.data.data;
  }

  async detail(register: string | number): Promise<unknown> {
    const response = await http.getData(`/register/${register}/riwayat-detail`);

    return response.data.data;
  }
}

export default new RiwayatPemeriksaan();
